import get from 'lodash.get';
import React, { forwardRef, useImperativeHandle } from 'react';

import { customerRecover, getError } from '../../services/shopify';

const PasswordRecover = (
  {
    children,
    setError = () => {},
    setLoading = () => {},
    setSuccess = () => {},
  },
  ref
) => {
  useImperativeHandle(ref, () => ({
    onSubmit({ email }, e) {
      setLoading(true);

      customerRecover({
        email,
      })
        .then((data) => {
          const errors = get(data, 'customerRecover.customerUserErrors', []);

          if (errors[0]) {
            setLoading(false);
            setError(getError(errors[0]));
          } else {
            setLoading(false);
            setError('');
            setSuccess(
              'Please check your email for a link to reset your password.'
            );

            if (e && e.target) {
              e.target.reset();
            }
          }
        })
        .catch((err) => {
          const errors = get(
            JSON.parse(JSON.stringify(err)),
            'response.errors',
            []
          );

          setLoading(false);
          setError(getError(errors[0]));
        });
    },
  }));

  return <>{children}</>;
};

export default forwardRef(PasswordRecover);
